<template lang="pug">
  .account-information
    .acount-header(v-if="!$parent.quote")
      h2 My Account
      a(v-if="!newPassword" @click="locked = !locked")
        svg(xmlns="http://www.w3.org/2000/svg" width="18.004" height="16" viewBox="0 0 18.004 16")
          path(d="M12.584,2.7,15.4,5.517a.306.306,0,0,1,0,.431L8.577,12.774l-2.9.322A.608.608,0,0,1,5,12.424l.322-2.9L12.152,2.7a.306.306,0,0,1,.431,0Zm5.063-.716L16.122.456a1.222,1.222,0,0,0-1.725,0L13.29,1.563a.306.306,0,0,0,0,.431l2.819,2.819a.306.306,0,0,0,.431,0l1.106-1.106a1.222,1.222,0,0,0,0-1.725ZM12,10.918V14.1H2V4.1H9.183a.384.384,0,0,0,.266-.109l1.25-1.25a.375.375,0,0,0-.266-.641H1.5A1.5,1.5,0,0,0,0,3.6v11a1.5,1.5,0,0,0,1.5,1.5h11A1.5,1.5,0,0,0,14,14.6V9.667a.376.376,0,0,0-.641-.266l-1.25,1.25A.384.384,0,0,0,12,10.918Z" transform="translate(0 -0.1)")
        span(v-if="locked") Edit
        span(v-else) Cancel
      a(v-else @click="goBack")
        span Back
    .error(v-if="errorMsg") {{ errorMsg }}
    form(v-if="!newPassword" v-on:keyup="checkSubmit" @click="clickEvent" :class="[locked ? 'form-locked' : 'form-edit', !$parent.quote ? 'parent' : 'child']")
      label(:class="!accountInfo.name && submitCheck ? 'field-error' : ''") My Name
      input(type="text" v-model="accountInfo.name" :disabled="locked" :class="!accountInfo.name && submitCheck ? 'field-error' : ''")
      label(:class="!accountInfo.business && submitCheck ? 'field-error' : ''") Company Name
      input(type="text" v-model="accountInfo.business" :disabled="locked" :class="!accountInfo.business && submitCheck ? 'field-error' : ''")
      label(:class="!accountInfo.industry && submitCheck ? 'field-error' : ''") Industry
      .dropdown.select-industry
        span.header.toggleDropDown.primary(@click="clickDropDownToggle()" :class="dropDownToggle ? 'open' : 'closed'") {{ accountInfo.primaryIndustry ? accountInfo.primaryIndustry : accountInfo.industry ? accountInfo.industry : 'Select One' }}
          svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414" :class="dropDownToggle ? 'flip' : ''")
            path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
        .options(v-if="dropDownToggle")
          span(@click="selectDropDown") Architect / Design
          span(@click="selectDropDown") Corporation
          span(@click="selectDropDown") Dealers
          span(@click="selectDropDown") Education
          span(@click="selectDropDown") Government
          span(@click="selectDropDown") Healthcare
          span(@click="selectDropDown") Hospitality
          span(@click="selectDropDown") Public Assembly
          span(@click="selectDropDown") Residential
          span(@click="selectDropDown") Restaurant
          span(@click="selectDropDown") Senior Living
          span(@click="selectDropDown") Worship / Church
      label(v-if="primaryArray.includes(accountInfo.industry) || primaryArray.includes(accountInfo.primaryIndustry)" :class="!accountInfo.primaryIndustry && submitCheck ? 'field-error' : ''") Sub Industry
      .dropdown.select-sub-industry(v-if="primaryArray.includes(accountInfo.industry) || primaryArray.includes(accountInfo.primaryIndustry)")
        span.header.toggleDropDown.secondary(@click="clickSubDropDownToggle()" :class="subDropDownToggle ? 'open' : 'closed'") {{ accountInfo.primaryIndustry == '' ? 'Select One' : accountInfo.industry }}
          svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414" :class="subDropDownToggle ? 'flip' : ''")
            path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
        .options(v-if="subDropDownToggle && accountInfo.industry == 'Architect / Design' || subDropDownToggle && accountInfo.primaryIndustry == 'Architect / Design'")
          span(@click="selectSubDropDown") Hospitality Design
          span(@click="selectSubDropDown") Senior Living Design
          span(@click="selectSubDropDown") Other Design
        .options(v-else-if="subDropDownToggle && accountInfo.industry == 'Dealers' || subDropDownToggle && accountInfo.primaryIndustry == 'Dealers'")
          span(@click="selectSubDropDown") Office Product Dealers
          span(@click="selectSubDropDown") Education Only Dealers
          span(@click="selectSubDropDown") Food Service Dealers
          span(@click="selectSubDropDown") Other Dealers
        .options(v-else-if="subDropDownToggle && accountInfo.industry == 'Hospitality' || subDropDownToggle && accountInfo.primaryIndustry == 'Hospitality'")
          span(@click="selectSubDropDown") Country Club
          span(@click="selectSubDropDown") Food Service Dealers
          span(@click="selectSubDropDown") Hotel Management
          span(@click="selectSubDropDown") Hotel Full Service
          span(@click="selectSubDropDown") Hotel Select / Limited Service
          span(@click="selectSubDropDown") Purchasing Group
          span(@click="selectSubDropDown") Ownership & Management Group
          span(@click="selectSubDropDown") Other Hospitality
        .options(v-else-if="subDropDownToggle && accountInfo.industry == 'Public Assembly' || subDropDownToggle && accountInfo.primaryIndustry == 'Public Assembly'")
          span(@click="selectSubDropDown") Convention, Conference & Civic Centers
          span(@click="selectSubDropDown") Performing Arts
          span(@click="selectSubDropDown") Stadiums & Arenas
          span(@click="selectSubDropDown") Other Public Assembly
      label.tax-exempt(v-if="!locked")
        input(v-if="!locked" type="checkbox" v-model="accountInfo.taxExempt")
        span We are Tax-Exempt <em>(Verification required)</em>
      label(v-else) {{ accountInfo.taxExempt ? 'Yes, we are tax-exempt' : 'No, we are not tax-exempt'}}
      label(:class="!validPhoneNumber && submitCheck ? 'field-error' : ''") Phone Number
      input(type="tel" v-model="accountInfo.phoneNumber" :disabled="locked" :class="!validPhoneNumber && submitCheck ? 'field-error' : ''")
      label(v-if="locked") Delivery Address

      div(v-if="!locked")
        label(:class="!accountInfo.country && submitCheck ? 'field-error' : ''") Country 
        .dropdown.select-country
          span.header.toggleDropDown.primary(@click="clickCountryDropDownToggle()" :class="countryDropDownToggle ? 'open' : 'closed'") {{ accountInfo.country ? accountInfo.country : 'Select Country' }}
            svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414" :class="countryDropDownToggle ? 'flip' : ''")
              path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
          .options.country-drop-down(v-if="countryDropDownToggle")
            span(v-for="country in addressCountries" v-bind:key="country.iso2" :value="country.iso2" @click="selectCountry") {{ country.name }}
      
      label(v-if="!locked" :class="!accountInfo.street && submitCheck ? 'field-error' : ''") Street
      input(type="text" v-model="accountInfo.street" :disabled="locked" :class="!accountInfo.street && submitCheck ? 'field-error' : ''")
      
      input(v-if="locked" type="text" :disabled="locked" :value="inlineAddress()")

      label(v-if="!locked" :class="!accountInfo.city && submitCheck ? 'field-error' : ''") City
      input(v-if="!locked" type="text" v-model="accountInfo.city" :disabled="locked" :class="!accountInfo.city && submitCheck ? 'field-error' : ''")
      
      div(v-if="!locked && addressStates.length > 0")
        label(v-if="!locked" :class="!accountInfo.state && submitCheck ? 'field-error' : ''") State / Province
        .dropdown.select-state
          span.header.toggleDropDown.primary(@click="clickStateDropDownToggle()" :class="stateDropDownToggle ? 'open' : 'closed'") {{ accountInfo.state ? accountInfo.state : 'Select State / Province' }}
            svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414" :class="stateDropDownToggle ? 'flip' : ''")
              path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
          .options.state-drop-down(v-if="stateDropDownToggle")
            span(v-for="state in addressStates" v-bind:key="state.iso2" :value="state.iso2" @click="selectState") {{ state.name }}

      label(v-if="!locked" :class="!validPostalCode && submitCheck ? 'field-error' : ''") Postal Code
      input(v-if="!locked" type="text" v-model="accountInfo.postalCode" :disabled="locked" :class="!validPostalCode && submitCheck ? 'field-error' : ''")
      input(v-if="locked" type="text" v-model="accountInfo.country" :disabled="locked" :class="!accountInfo.country && submitCheck ? 'field-error' : ''")
    
      button(v-if="!$parent.quote && !locked" type="button" @click="saveAccount") Save Account

    .change-password(v-if="locked && !newPassword" @click="changePassword")
      a
        svg(xmlns="http://www.w3.org/2000/svg" width="16" height="16.714" viewBox="0 0 16 16.714")
          path(d="M34.44,18.464,33,17.635a6.491,6.491,0,0,0,0-2.366l1.435-.829a.407.407,0,0,0,.185-.472,8.392,8.392,0,0,0-1.843-3.188.405.405,0,0,0-.5-.078l-1.435.829A6.359,6.359,0,0,0,28.8,10.35V8.7a.4.4,0,0,0-.317-.394,8.471,8.471,0,0,0-3.68,0,.4.4,0,0,0-.317.394v1.658a6.56,6.56,0,0,0-2.049,1.183L21,10.707a.4.4,0,0,0-.5.078,8.342,8.342,0,0,0-1.843,3.188.4.4,0,0,0,.185.472l1.435.829a6.491,6.491,0,0,0,0,2.366l-1.435.829a.407.407,0,0,0-.185.472,8.393,8.393,0,0,0,1.843,3.188.405.405,0,0,0,.5.078l1.435-.829a6.359,6.359,0,0,0,2.049,1.183v1.658a.4.4,0,0,0,.317.394,8.471,8.471,0,0,0,3.68,0,.4.4,0,0,0,.317-.394V22.558a6.56,6.56,0,0,0,2.049-1.183l1.435.829a.4.4,0,0,0,.5-.078,8.342,8.342,0,0,0,1.843-3.188A.416.416,0,0,0,34.44,18.464Zm-7.8.684a2.7,2.7,0,1,1,2.7-2.7A2.7,2.7,0,0,1,26.642,19.148Z" transform="translate(-18.644 -8.099)")
        | Change Password
    change-password(v-if="newPassword")
</template>

<script>
import Accounts from "../scripts/accounts.js";
import Activity from "../scripts/activity.js";
import { Country } from "../scripts/country-state.js";

export default {
  name: "Account",
  data() {
    return {
      errorMsg: "",
      accountInfo: {},
      submitCheck: false,
      locked: true,
      dropDownToggle: false,
      countryDropDownToggle: false,
      stateDropDownToggle: false,
      subDropDownToggle: false,
      newPassword: false,
      primaryArray: [
        "Architect / Design",
        "Dealers",
        "Hospitality",
        "Public Assembly"
      ],
      addressCountries: {},
      addressStates: {}
    };
  },
  computed: {
    validPostalCode() {
      var zip = this.accountInfo.postalCode;

      var us = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/; // USA
      var canada = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/; // Canada
      var uk = /^([A-Za-z]{1,2}\d[A-Za-z\d]? \d[A-Za-z]{2}|GIR 0AA)$/; // UK
      var australia = /^\d{4}$/; // Australia
      var multi = /^\d{5}$/; // France, Germany, Italy, Mexico
      var japan = /^\d{3}-\d{4}$/; // Japan
      var netherlands = /^\d{4} ?[A-Za-z]{2}$/; // Netherlands
      var brazil = /^\d{5}-\d{3}$/; // Brazil

      return (
        us.test(zip) ||
        canada.test(zip) ||
        uk.test(zip) ||
        australia.test(zip) ||
        multi.test(zip) ||
        japan.test(zip) ||
        netherlands.test(zip) ||
        brazil.test(zip)
      );
    },
    validPhoneNumber: function() {
      if (
        /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(
          this.accountInfo.phoneNumber
        ) != false
      ) {
        return true;
      } else {
        return false;
      }
    },
    verifyInfo() {
      if (
        this.validPhoneNumber &&
        this.validPostalCode &&
        this.accountInfo.business &&
        this.accountInfo.city &&
        this.accountInfo.country &&
        this.accountInfo.industry &&
        this.accountInfo.name &&
        (this.accountInfo.state || this.addressStates.length == 0) &&
        this.accountInfo.street &&
        !this.primaryArray.includes(this.accountInfo.industry)
      ) {
        this.errorMsg = "";
        return true;
      } else {
        this.errorMsg = "Please correct all invalid fields";
        return false;
      }
    }
  },
  methods: {
    saveAccount() {
      this.submitCheck = true;
      if (this.verifyInfo) {
        console.log("Save Account");
        this.locked = true;
        this.$root.currentUser.name = this.accountInfo.name;
        Accounts.saveAccount(this.accountInfo);

        if (!this.$parent.quote) {
          this.$root.confirmation.msg = "Changes Saved!";
          this.$root.confirmation.returnState = "account";
          this.$root.confirmation.returnMsg = "View Account";
          this.$root.confirmation.open = true;
        }

        Activity.userActivity(
          this.$root.currentUser,
          "profile:edit",
          this.accountInfo
        );
      }
    },
    inlineAddress() {
      return `${this.accountInfo.city}, ${this.accountInfo.state} ${this.accountInfo.postalCode}`;
    },
    selectSubDropDown(e) {
      this.subDropDownToggle = false;
      if (!this.accountInfo.primaryIndustry) {
        this.accountInfo.primaryIndustry = this.accountInfo.industry;
      }
      this.accountInfo.industry = e.target.innerText;
    },
    selectCountry(e) {
      this.accountInfo.country = e.target.innerText;
      this.accountInfo.countryAbbr = e.target.getAttribute("value");
      this.accountInfo.state = "";
      this.clickCountryDropDownToggle();
      Country.getStatesOfCountry(this.accountInfo.countryAbbr).then(states => {
        this.addressStates = states.sort((a, b) => (a.name > b.name ? 1 : -1));
      });
    },
    selectState(e) {
      this.accountInfo.state = e.target.getAttribute("value");
      this.clickStateDropDownToggle();
    },
    clickDropDownToggle() {
      if (!this.locked) {
        this.dropDownToggle = !this.dropDownToggle;
        this.subDropDownToggle = false;
        this.countryDropDownToggle = false;
        this.stateDropDownToggle = false;
      }
    },
    clickSubDropDownToggle() {
      if (!this.locked) {
        this.subDropDownToggle = !this.subDropDownToggle;
        this.dropDownToggle = false;
        this.countryDropDownToggle = false;
        this.stateDropDownToggle = false;
      }
    },
    clickCountryDropDownToggle() {
      if (!this.locked) {
        this.countryDropDownToggle = !this.countryDropDownToggle;
        this.dropDownToggle = false;
        this.subDropDownToggle = false;
        this.stateDropDownToggle = false;
      }
    },
    clickStateDropDownToggle() {
      if (!this.locked) {
        this.stateDropDownToggle = !this.stateDropDownToggle;
        this.dropDownToggle = false;
        this.subDropDownToggle = false;
        this.countryDropDownToggle = false;
      }
    },
    selectDropDown(e) {
      this.dropDownToggle = false;
      this.accountInfo.industry = e.target.innerText;
      this.accountInfo.primaryIndustry = "";
    },
    clickEvent(e) {
      // Check
      if (e.target.classList.length === 0) {
        this.dropDownToggle = false;
        this.stateDropDownToggle = false;
        this.subDropDownToggle = false;
        this.countryDropDownToggle = false;
      }
    },
    changePassword() {
      this.newPassword = true;
    },
    goBack() {
      this.newPassword = false;
    },
    checkSubmit(e) {
      if (e && e.keyCode == 13) {
        this.saveAccount();
      }
    }
  },
  mounted: function() {
    this.$root.currentPage = "Account Information";
    if (this.$parent.quote) {
      this.locked = false;
    }

    //Sort United States and Canada to Top of Array List
    Country.getAllCountries().then(countries => {
      this.addressCountriesData = countries;

      for (var data in this.addressCountriesData) {
        if (
          this.addressCountriesData[data].name == "United States" ||
          this.addressCountriesData[data].name == "Canada"
        ) {
          var tmp = this.addressCountriesData[data];

          this.addressCountriesData.splice(data, 1);
          this.addressCountriesData.unshift(tmp);
        }
      }

      this.addressCountries = this.addressCountriesData;
    });

    if (!this.$root.currentUser.guest) {
      Accounts.getAccount(this.$root.currentUser.uid).then(results => {
        this.accountInfo = results;
        this.accountInfo.uid = this.$root.currentUser.uid;

        //Check existing account for COUNTRY abbreviation
        if (!this.accountInfo.countryAbbr) {
          Country.getAllCountries().then(allCountries => {
            for (var i in allCountries) {
              if (allCountries[i].name == this.accountInfo.country) {
                this.accountInfo.countryAbbr = allCountries[i].iso2;
              }
            }

            Accounts.saveAccount(this.accountInfo);
          });
        }

        //Check for selected country
        if (this.accountInfo.country && this.accountInfo.countryAbbr) {
          Country.getStatesOfCountry(this.accountInfo.countryAbbr).then(
            states => {
              this.addressStates = states.sort((a, b) =>
                a.name > b.name ? 1 : -1
              );
            }
          );
        }
      });
    }
  }
};
</script>

<style lang="scss">
@import "../assets/styles/variables.scss";

#app .account-information {
  .acount-header {
    align-items: center;
    background-color: $light_gray;
    display: flex;
    height: auto;
    justify-content: space-between;
    padding: 24px;

    h2 {
      color: $text_color;
    }

    svg {
      fill: $link_color;
      margin-right: 0.3em;
    }

    a span {
      vertical-align: text-top;
    }
    a:hover svg {
      fill: $link_hover;
    }
  }
  form {
    &.parent {
      padding: 0 24px 24px;
    }
    label {
      display: block;
      font-size: 0.9em;
      margin: 0.8em 0;
    }

    .dropdown {
      position: relative;
      width: 100%;
      span {
        border: 1px $light_gray solid;
        cursor: pointer;
        display: block;
        font-size: 0.9em;
        margin-top: -1px;
        padding: 1em;

        &:hover {
          background: #f6e4c1;
        }
      }
      .header {
        background: $light_gray;
        border-radius: 5px;

        &.open {
          border-radius: 5px 5px 0 0;
        }
        svg {
          float: right;
          height: 15px;
          width: 15px;
          &.flip {
            transform: rotate(180deg);
          }
        }
      }
      .options {
        background: #fff;
        position: absolute;
        width: 100%;
        z-index: 10;

        span:last-of-type {
          border-radius: 0 0 5px 5px;
        }
      }

      .country-drop-down,
      .state-drop-down {
        max-height: 400px;
        overflow-y: scroll;
      }
    }

    input {
      border: 1px $border_gray solid;
      border-radius: 7px;
      padding: 1em 0.5em;
      position: relative;
      width: 100%;
    }

    input[type="checkbox"] {
      height: 20px;
      width: 20px;
    }

    label.field-error {
      color: red;
    }

    input.field-error,
    select.field-error {
      border: 1px solid red;
    }

    .tax-exempt {
      align-items: center;
      display: flex;
      font-size: 0.8em;
      margin: 1.3em 0;

      input {
        margin-right: 0.7em;
        margin-bottom: 0em;
      }

      em {
        font-size: 0.9em;
      }
    }
  }

  .form-locked {
    input {
      border: none;
      border-radius: 0;
      color: $text_color;
      opacity: 1;
      font-size: 14px;
      background: #eee;
      margin-bottom: 0.5em;
    }

    .dropdown {
      span {
        background: #eee;
        border: 1px $light_gray solid;
        cursor: inherit;
        display: block;
        margin-top: -1px;
        padding: 1em 0.5em;
        border-radius: 0;
        &:hover {
          background: #eee;
        }
      }
      .header {
        border: none;

        svg {
          display: none;
        }
      }
    }
  }

  .change-password {
    padding: 0em 24px 1em;
    a {
      &:hover {
        svg path {
          fill: $link_hover;
        }
      }
    }
    svg {
      margin-right: 0.5em;
      vertical-align: bottom;
      path {
        fill: $link_color;
      }
    }
  }
}
</style>
